// extracted by mini-css-extract-plugin
module.exports = {"paymentColumn":"PaymentPage_paymentColumn__1WwkJ","paymentContainer":"PaymentPage_paymentContainer__TG0Et"};